import { Hub } from 'aws-amplify/utils';
import { readSocialAuthContext, storeSocialAuthContext } from './socialAuthContext';

type CallbackStatus = 'idle' | 'pending' | 'success' | 'failure';
let status: CallbackStatus = 'idle';
const listeners = new Set<() => void>();

export function getSocialCallbackStatus() {
  return status;
}

export function subscribeSocialCallback(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function updateStatus(next: CallbackStatus) {
  status = next;
  listeners.forEach((listener) => listener());
}

export function beginSocialRedirect() {
  updateStatus('pending');
}
export function resetSocialCallback() {
  updateStatus('idle');
}

export function recordSocialCallback(success: boolean) {
  const context = readSocialAuthContext();
  if (context?.kind === 'invite' && context.phase === 'linked') {
    updateStatus('success');
    return;
  }
  if (context?.kind === 'invite') {
    try {
      storeSocialAuthContext({ ...context, phase: success ? 'authenticated' : 'failed' });
    } catch {
      // The Hub result remains authoritative when progress cannot be persisted.
    }
  }
  updateStatus(success ? 'success' : 'failure');
}

/** Subscribe before configuring Amplify so completion is retained before React mounts. */
export function initializeSocialCallback() {
  const params = new URLSearchParams(window.location.search);
  const isCognitoCallback = ['/auth-success'].includes(window.location.pathname);
  if (isCognitoCallback && params.has('state') && (params.has('code') || params.has('error'))) {
    updateStatus('pending');
  }
  return Hub.listen('auth', ({ payload }) => {
    if (payload.event === 'signInWithRedirect') recordSocialCallback(true);
    if (payload.event === 'signInWithRedirect_failure') recordSocialCallback(false);
  });
}
